import { isEmpty, isNil } from 'ramda';

/**
 * Returns true if not null or undefined
 */
export const hasValue = (a: any) => !isNil(a);

/**
 * Returns true if not null or undefined or empty ("", [], {})
 */
export const hasNonEmptyValue = (a: any) => !isNil(a) && !isEmpty(a);

/**
 * Returns true if null or undefined or empty ("", [], {})
 */
export const hasEmptyValue = (a: any) => isNil(a) || isEmpty(a);

/**
 * Returns a function that returns the parameter if it has a value,
 * and defaultValue if not.
 */
export const valueOrDefault = <T>(defaultValue: T) => (a: T) => a ?? defaultValue;
